import Model from '@/models/Model'

export default class APartialReception extends Model {
    resource() {
        return 'partial_reception'
    }
}